module.exports = __webpack_public_path__ + "img/img_srm.ab649111.png";